export const jurisdictionOptions = [
    {
        label: 'Alaska (AK)',
        value: 'alaska'
    },
    {
        label: 'Alabama (AL)',
        value: 'alabama'
    },
    {
        label: 'Arkansas (AR)',
        value: 'arkansas'
    },
    {
        label: 'Arizona (AZ)',
        value: 'arizona'
    },
    {
        label: 'California (CA)',
        value: 'california'
    },
    {
        label: 'Colorado (CO)',
        value: 'colorado'
    },
    {
        label: 'Connecticut (CT)',
        value: 'connecticut'
    },
    {
        label: 'District of Columbia (DC)',
        value: 'district_of_columbia'
    },
    {
        label: 'Delaware (DE)',
        value: 'delaware'
    },
    {
        label: 'Florida (FL)',
        value: 'florida'
    },
    {
        label: 'Georgia (GA)',
        value: 'georgia'
    },
    {
        label: 'Guam (GU)',
        value: 'guam'
    },
    {
        label: 'Hawaii (HI)',
        value: 'hawaii'
    },
    {
        label: 'Idaho (ID)',
        value: 'idaho'
    },
    {
        label: 'Illinois (IL)',
        value: 'illinois'
    },
    {
        label: 'Indiana (IN)',
        value: 'indiana'
    },
    {
        label: 'Iowa (IA)',
        value: 'iowa'
    },
    {
        label: 'Kansas (KS)',
        value: 'kansas'
    },
    {
        label: 'Kentucky (KY)',
        value: 'kentucky'
    },
    {
        label: 'Louisiana (LA)',
        value: 'louisiana'
    },
    {
        label: 'Maine (ME)',
        value: 'maine'
    },
    {
        label: 'Maryland (MD)',
        value: 'maryland'
    },
    {
        label: 'Massachussets (Ma)',
        value: 'massachussets'
    },
    {
        label: 'Michigan (MI)',
        value: 'michigan'
    },
    {
        label: 'Minnesota (MN)',
        value: 'minnesota'
    },
    {
        label: 'Mississippi (MS)',
        value: 'mississippi'
    },
    {
        label: 'Missouri (MO)',
        value: 'missouri'
    },
    {
        label: 'Montana (MT)',
        value: 'montana'
    },
    {
        label: 'Nebraska (NE)',
        value: 'nebraska'
    },
    {
        label: 'Nevada (NV)',
        value: 'nevada'
    },
    {
        label: 'New Hampshire (NH)',
        value: 'new_hampshire'
    },
    {
        label: 'New Jersey (NJ)',
        value: 'new_jersey'
    },
    {
        label: 'New Mexico (NM)',
        value: 'new_mexico'
    },
    {
        label: 'New York (NY)',
        value: 'new_york'
    },
    {
        label: 'North Carolina (NC)',
        value: 'north_carolina'
    },
    {
        label: 'North Dakota (ND)',
        value: 'north_dakota'
    },
    {
        label: 'Ohio (OH)',
        value: 'ohio'
    },
    {
        label: 'Oklahoma (OK)',
        value: 'oklahoma'
    },
    {
        label: 'Oregon (OR)',
        value: 'oregon'
    },
    {
        label: 'Pennsylvania (PA)',
        value: 'pennsylvania'
    },
    {
        label: 'Puerto Rico (PR)',
        value: 'puerto_rico'
    },
    {
        label: 'Rhode Island (RI)',
        value: 'rhode_island'
    },
    {
        label: 'South Carolina (SC)',
        value: 'south_carolina'
    },
    {
        label: 'South Dakota (SD)',
        value: 'south_dakota'
    },
    {
        label: 'Tennessee (TN)',
        value: 'tennessee'
    },
    {
        label: 'Texas (TX)',
        value: 'texas'
    },
    {
        label: 'Utah (UT)',
        value: 'utah'
    },
    {
        label: 'Vermont (VT)',
        value: 'vermont'
    },
    {
        label: 'Virginia (VA)',
        value: 'virginia'
    },
    {
        label: 'Virgin Islands (VI)',
        value: 'virginislands'
    },
    {
        label: 'Washington (WA)',
        value: 'washington'
    },
    {
        label: 'West Virginia (WV)',
        value: 'west_virginia'
    },
    {
        label: 'Wisconsin (WI)',
        value: 'wisconsin'
    },
    {
        label: 'Wyoming (WY)',
        value: 'wyoming'
    }
];
